export function setWebpackPublicPath() {
    if (__webpack_public_path__.startsWith("/")) {
        __webpack_public_path__ = window.ocm.config.resourcesHostname + __webpack_public_path__;
    }
}